import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { RoswellQueuePage, RoswellQueueQuery, RoswellStatusOverview } from './roswell-status.models';

interface RoswellResponse<T> {
  ok: boolean;
  data?: T;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class RoswellStatusService {
  private readonly endpoint = '/api/roswell/status.php';

  constructor(private readonly http: HttpClient) {}

  status(): Observable<RoswellStatusOverview> {
    return this.http.get<RoswellResponse<RoswellStatusOverview>>(this.endpoint, {
      params: new HttpParams().set('action', 'overview')
    }).pipe(map(response => this.data(response)));
  }

  queue(query: RoswellQueueQuery): Observable<RoswellQueuePage> {
    let params = new HttpParams().set('action', 'issues').set('limit', String(query.limit));
    if (query.view) params = params.set('view', query.view);
    if (query.direction) params = params.set('direction', query.direction);
    if (query.status) params = params.set('status', query.status);
    if (query.component) params = params.set('component', query.component);
    if (query.after) params = params.set('after', query.after);
    return this.http.get<RoswellResponse<RoswellQueuePage>>(this.endpoint, { params })
      .pipe(map(response => this.data(response)));
  }

  private data<T>(response: RoswellResponse<T>): T {
    if (!response.ok || response.data === undefined) {
      throw new Error(response.message || 'Roswell status is temporarily unavailable.');
    }
    return response.data;
  }
}
